import type { TransactionDetail } from '@pkg/solana'
import { PROGRAM_IDS } from '../constants'

export function haveTokenTransfers(transaction: TransactionDetail): boolean {
  if (!transaction.meta?.innerInstructions) {
    return false
  }

  return transaction.meta.innerInstructions.some((inner) =>
    inner.instructions.some((instruction) => {
      const programId = instruction.programId.toString()
      return (
        programId === PROGRAM_IDS.TOKEN || programId === PROGRAM_IDS.TOKEN_2022
      )
    }),
  )
}
